import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  button: {
    borderRadius: "100px",
    padding: "8px 20px",
    "& span": {
      marginLeft: "0px",
    },
  },
  outlined: {
    border: "1px solid #0344DC",
    backgroundColor: "transparent",
    color: "#0344DC",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(16),
    "&:hover": {
      backgroundColor: "transparent",
      color: "#0344DC",
    },
  },
  contained: {
    border: "0px",
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 600,
    color: "#0344DC",
    backgroundColor: "#F1F5FF",
    "&:hover": {
      color: "#0344DC",
      backgroundColor: "#F1F5FF",
    },
  },
  secondary: {
    backgroundColor: "#0344DC",
    color: "white",
    "&:hover": {
      backgroundColor: "#0344DC",
      color: "white",
    },
  },
}));
